import { useState, useEffect } from 'react';
import baseURL from './url';

const STORAGE_KEY = 'agencia_site_config';

export function aplicarConfiguracionEnDOM(config) {
    if (!config) return;

    // Aplicar colores dinámicos como variables CSS en :root
    if (config.color_menu_movil) {
        document.documentElement.style.setProperty('--color-menu-movil', config.color_menu_movil);
        document.documentElement.style.setProperty('--color1', config.color_menu_movil);
        document.documentElement.style.setProperty('--color2', config.color_menu_movil);
        document.documentElement.style.setProperty('--loading', config.color_menu_movil + '77');
    }
    if (config.color_footer) {
        document.documentElement.style.setProperty('--color-footer', config.color_footer);
    }
    if (config.footer_bg_image) {
        document.documentElement.style.setProperty('--footer-bg-image', `url("${config.footer_bg_image}")`);
    } else {
        document.documentElement.style.setProperty('--footer-bg-image', 'none');
    }
    const footerOpacity = config.footer_bg_opacity !== undefined && config.footer_bg_opacity !== '' ? config.footer_bg_opacity : '0.70';
    document.documentElement.style.setProperty('--footer-bg-opacity', footerOpacity);

    // Actualizar título del documento si existe
    if (config.meta_title) {
        document.title = config.meta_title;
    }

    // Aplicar Favicon dinámico en el <head>
    if (config.favicon) {
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'shortcut icon';
            document.head.appendChild(link);
        }
        link.href = config.favicon;
    }
}

export function notificarCambioConfiguracion(nuevaConfig) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(nuevaConfig));
        localStorage.setItem('dxn_site_config', JSON.stringify(nuevaConfig));
    } catch (e) {}
    aplicarConfiguracionEnDOM(nuevaConfig);
    window.dispatchEvent(new CustomEvent('agencia_site_config_updated', { detail: nuevaConfig }));
    window.dispatchEvent(new CustomEvent('dxn_site_config_updated', { detail: nuevaConfig }));
}

export default function useSiteConfig() {
    const [config, setConfig] = useState(() => {
        try {
            const cached = localStorage.getItem(STORAGE_KEY) || localStorage.getItem('dxn_site_config');
            if (cached) {
                const parsed = JSON.parse(cached);
                aplicarConfiguracionEnDOM(parsed);
                return parsed;
            }
        } catch (e) {}
        return {
            logo: '',
            favicon: '',
            color_menu_movil: '#059669',
            color_footer: '#064E3B',
            footer_bg_image: '',
            footer_bg_opacity: '0.70',
            slogan: 'Tu agencia de confianza, viajes y experiencias inolvidables',
            telefono_reservas: '',
            whatsapp_reservas: '',
            email_reservas: '',
            direccion_agencia: '',
            horario_atencion: '',
            registro_turismo: '',
            moneda_default: 'PEN',
            mensaje_emergencia: '',
            pwa_activo: '1',
            pwa_nombre: 'SEYLIS TOURS',
            pwa_descripcion: 'Instala la app oficial y planifica tus viajes con facilidad'
        };
    });

    useEffect(() => {
        // Cargar desde API
        fetch(`${baseURL}/configuracionGet.php`)
            .then(res => res.json())
            .then(data => {
                if (data && data.config) {
                    setConfig(data.config);
                    try {
                        localStorage.setItem(STORAGE_KEY, JSON.stringify(data.config));
                    } catch (e) {}
                    aplicarConfiguracionEnDOM(data.config);
                }
            })
            .catch(err => {
                console.warn('No se pudo obtener configuración en vivo:', err);
            });

        // Escuchar eventos locales de actualización (cuando se guarde en admin)
        const handleConfigUpdate = (e) => {
            if (e.detail) {
                setConfig(prev => ({ ...prev, ...e.detail }));
                aplicarConfiguracionEnDOM(e.detail);
            }
        };

        window.addEventListener('agencia_site_config_updated', handleConfigUpdate);
        window.addEventListener('dxn_site_config_updated', handleConfigUpdate);
        return () => {
            window.removeEventListener('agencia_site_config_updated', handleConfigUpdate);
            window.removeEventListener('dxn_site_config_updated', handleConfigUpdate);
        };
    }, []);

    return {
        config,
        logo: config?.logo || '',
        favicon: config?.favicon || '',
        color_menu_movil: config?.color_menu_movil || '#059669',
        color_footer: config?.color_footer || '#064E3B',
        footer_bg_image: config?.footer_bg_image || '',
        footer_bg_opacity: config?.footer_bg_opacity !== undefined ? config.footer_bg_opacity : '0.70',
        slogan: config?.slogan || '',
        telefono_reservas: config?.telefono_reservas || '',
        whatsapp_reservas: config?.whatsapp_reservas || '',
        email_reservas: config?.email_reservas || '',
        direccion_agencia: config?.direccion_agencia || '',
        horario_atencion: config?.horario_atencion || '',
        registro_turismo: config?.registro_turismo || '',
        moneda_default: config?.moneda_default || 'PEN',
        mensaje_emergencia: config?.mensaje_emergencia || '',
        pwa_activo: config?.pwa_activo !== undefined ? String(config.pwa_activo) : '1',
        pwa_nombre: config?.pwa_nombre || config?.site_name || 'SEYLIS TOURS',
        pwa_descripcion: config?.pwa_descripcion || 'Instala la app oficial y planifica tus viajes con facilidad'
    };
}

